import {
  CLEMENT_BIO,
  CLEMENT_PHOTO_URL,
  MATHIEU_PHOTO_URL,
  NOMADS_LAND_URL,
  Tournons_la_page_URL,  
} from "../aboutAssets";

export function AboutSection() {
  return (  
    <section className="section about-section" id="qui-sommes-nous">
      <div className="section-heading">
        <p className="kicker">Qui sommes nous ?</p>
        <h2>Une troupe qui rit du pouvoir de près</h2>
      </div>
      <div className="about-grid">
        <article className="about-member">
          <img
            className="about-photo"
            src={MATHIEU_PHOTO_URL}
            alt="Photo de Mathieu Pourchier"
          />
          <div className="about-copy">
            <h3>Mathieu POURCHIER</h3>
            <p>
              Diplômé de Sciences Po Grenoble en relations internationales, c'est sur le terrain qu'il a forgé son expertise,
              notamment au Niger, où il a œuvré pendant plusieurs années aux côtés des sociétés
              civiles africaines et européennes. Spécialiste des enjeux de démocratie, droits humains
              et espace civique, il a dirigé <a href={Tournons_la_page_URL} rel="noopener noreferrer" target="_blank">Tournons La Page</a>, un réseau international engagé dans
              la défense des libertés et la promotion de la participation citoyenne. Artiste engagé,
              il considère la scène comme un levier de questionnement et de résistance.
              Après avoir cofondé{" "}
              <a
                className="remerciements-link"
                href={NOMADS_LAND_URL}
                rel="noopener noreferrer"
                target="_blank"
              >
                Nomad's Land
              </a>
              , un groupe de chansons militantes, il se tourne vers le théâtre pour explorer de
              nouvelles formes d'expression.
            </p>
          </div>
        </article>
        <article className="about-member">
          <img
            className="about-photo"
            src={CLEMENT_PHOTO_URL}
            alt="Photo de Clément Fiquet"
          />
          <div className="about-copy">
            <h3>Clément FIQUET</h3>
            <p>{CLEMENT_BIO}</p>
          </div>
        </article>
      </div>
    </section>
  );
}
